import { type ReactNode } from "react";
import { Box, styled } from "~/common/mui";

interface MessageContainerBoxProps {
  children?: ReactNode;
  className?: string;
  id?: string;
}

const MsgBox = styled(Box)({
  padding: "10px 0",
  display: "flex",
  flexDirection: "column",
  "& > *:not(:last-child)": { marginBottom: "20px" },
});

const MessageContainerBox = (props: MessageContainerBoxProps) => {
  const { className, id } = props;

  return (
    <MsgBox className={className} id={id}>
      {props.children}
    </MsgBox>
  );
};

export default MessageContainerBox;
